import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Redirect } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import CONFIG from '../config'

import { isAdmin, isAuthenticated } from '../utils/AuthService'
import * as AuthenticationActionCreators from '../actions/authentication'

class LoginRequired extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    auth: PropTypes.object.isRequired,
    authActions: PropTypes.object.isRequired,
    ensureAdmin: PropTypes.bool,
  }

  static defaultProps = {
    ensureAdmin: false,
    children: null,
  }

  static styles = () => ({
    centered: {
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      height: '100vh',
      width: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
    },
  })

  static mapStateToProps(state) {
    return {
      auth: state.auth,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      authActions: bindActionCreators(AuthenticationActionCreators, dispatch),
    }
  }

  render() {
    const {
      children, auth, ensureAdmin, authActions,
    } = this.props
    if (isAuthenticated(auth)) {
      if (!ensureAdmin || isAdmin(auth)) {
        return children
      }

      // Admin check failed
      authActions.logout()
      window.location = CONFIG.blokable.dashboardBaseUrl
      return (
        'You do not have permission to view this page'
      )
    }

    return <Redirect to={{ pathname: '/login' }} />
  }
}

export default withRouter(connect(
  LoginRequired.mapStateToProps,
  LoginRequired.mapDispatchToProps,
)(withStyles(LoginRequired.styles)(LoginRequired)))
